import httpServices from './httpServices';

const StateAdminServices = {
  // Get combined state data (schools + metrics)
  getStateData: async () => {
    try {
      const response = await httpServices.get('state/data');
      return response;
    } catch (error) {
      console.error('Error fetching state data:', error);
      throw error;
    }
  },

  // Get schools for the state
  getStateSchools: async (filters = {}) => {
    try {
      const params = new URLSearchParams();
      if (filters.search) params.append('search', filters.search);
      if (filters.status) params.append('status', filters.status);
      if (filters.city) params.append('city', filters.city);
      if (filters.district) params.append('district', filters.district);
      
      const queryString = params.toString();
      const url = queryString ? `state/schools?${queryString}` : 'state/schools';
      const response = await httpServices.get(url);
      return response;
    } catch (error) {
      console.error('Error fetching state schools:', error);
      throw error;
    }
  },

  // Get state metrics
  getStateMetrics: async () => {
    try {
      const response = await httpServices.get('state/metrics');
      return response;
    } catch (error) {
      console.error('Error fetching state metrics:', error);
      throw error;
    }
  },

  // Get state analytics
  getStateAnalytics: async () => {
    try {
      const response = await httpServices.get('state/analytics');
      return response;
    } catch (error) {
      console.error('Error fetching state analytics:', error);
      throw error;
    }
  },

  // Get state reports
  getStateReports: async (params = {}) => {
    try {
      const queryParams = new URLSearchParams();
      if (params.startDate) queryParams.append('startDate', params.startDate);
      if (params.endDate) queryParams.append('endDate', params.endDate);
      if (params.reportType) queryParams.append('reportType', params.reportType);
      
      const queryString = queryParams.toString();
      const url = queryString ? `state/reports?${queryString}` : 'state/reports';
      const response = await httpServices.get(url);
      return response;
    } catch (error) {
      console.error('Error fetching state reports:', error);
      throw error;
    }
  },

  // Export state data
  exportStateData: async (format = 'csv', filters = {}) => {
    try {
      const params = {};
      params.format = format;
      if (filters.status) params.filter = filters.status;
      
      if (format === 'csv') {
        // Use getBlob for CSV exports
        const response = await httpServices.getBlob('state/export', params);
        return response.data;
      } else {
        // Use regular get for JSON exports
        const queryParams = new URLSearchParams();
        queryParams.append('format', format);
        if (filters.status) queryParams.append('filter', filters.status);
        
        const response = await httpServices.get(`state/export?${queryParams.toString()}`);
        return response;
      }
    } catch (error) {
      console.error('Error exporting state data:', error);
      throw error;
    }
  }
};

export default StateAdminServices;

